<template>
    <div class="component-tasks" id="budget-summary">
        <el-card class="box-card">
            <div slot="header" class="text-left">
                <h4>Current tasks</h4>
            </div>
            <template v-if="loaded">
                <el-table
                    ref="taskTable"
                    :data="tableData"
                    style="width: 100%"
                    :row-class-name="tableRowClassName"
                    @row-click="parentRowClicked"
                >

                    <el-table-column label="Type">
                        <template slot-scope="scope">
                            {{scope.row.ticket_name | formatVariableName}}
                        </template>
                    </el-table-column>

                    <el-table-column
                        v-for="col in headers"
                        :key="col.prop"
                        :prop="col.prop"
                        :label="col.label"
                    >
                    </el-table-column>

                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <div class="row">
                                <div class="col-6">
                                    <p class="" style="font-weight: 800; display: inline; line-height: 38px;">Task information</p><br>
                                    <p class="inline">{{getInfo(scope.row)}}</p>
                                </div>
                                <div class="col-6">
                                    <el-button plain class="fr ml-10" type="primary" v-if="scope.row.ticket_name !== 'Budget approve'" @click="modifyTicket(null, scope.row.ticket_name)" size="medium" @submit.prevent="submit">Complete all</el-button>
                                    <el-button v-show="viewAllVisible(scope.row)" plain class="fr" type="primary" @click="parentTicketClicked(scope.row)" size="medium" @submit.prevent="submit">View all</el-button>
                                </div>
                            </div>
                            <el-table
                                stripe
                                :data="scope.row.children"
                                style="width: 100%"
                                @row-click="taskClicked"
                            >
                                <el-table-column prop="store_id" label="Store"><template slot-scope="scope">{{$store.getters['general/getAllStores'].find(x => parseInt(x.store_id) === parseInt(scope.row.store_id)).store_name}}</template></el-table-column>
                                <el-table-column
                                    sortable
                                    v-for="col in ticketHeaders[scope.row.ticket_name]"
                                    :key="col.prop"
                                    :prop="col.prop"
                                    :label="col.label"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="Status"
                                    align="center">
                                    <template slot-scope="scope">
                                        <el-tag v-if="scope.row.modified === false" type="warning" disable-transitions>Open</el-tag>
                                        <el-tag v-if="scope.row.modified === true" type="success" disable-transitions>Completed</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="View"
                                    align="center">
                                    <el-button icon="el-icon-search" size="small" plain></el-button>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <div v-if="!loaded" class="loader-container">
                <facebook-loader :speed="3" :animate=true :height=130 :width=400></facebook-loader>
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import vue from 'vue'
import { getHeadersWithAccessToken, formatString } from '../functions'
import { FacebookLoader } from 'vue-content-loader'
export default {
    props: ['module'],
    data () {
        return {
            loaded: false,
            tableData: [],
            headers: [{ 'prop': 'days_open', 'label': 'Days open' }],
            ticketHeaders: {},
            messages: []
        }
    },
    methods: {
        viewAllVisible (row) {
            let message = this.messages.find(x => x.type_name === row.type_name)
            if (message === undefined) {
                return true
            } else if (message.linking.params.includes('store_ids')) {
                return true
            } else {
                return false
            }
        },
        getInfo (row) {
            let message = this.messages.find(x => x.type_name === row.type_name)
            if (message === undefined) {
                return 'Budget approve tasks'
            } else {
                return formatString(message.info)
            }
        },
        parentRowClicked (row) {
            this.$refs.taskTable.toggleRowExpansion(row)
        },
        parentTicketClicked (row) {
            this.modifyTicket(null, row.ticket_name)
            let message = this.messages.find(x => x.type_name === row.type_name)
            if (message !== undefined) {
                let route = { 'path': message.linking.url, 'query': {} }
                for (let param of message.linking.params) {
                    if (Object.keys(row).includes(param)) { // If param is also in the row, we can use it as query parameter
                        route['query'][param] = row[param]
                    }
                    if (param === 'store_ids') {
                        route['query'][param] = ''
                        for (let item of row.children) {
                            route['query'][param] += item.store_id + ','
                        }
                        route['query'][param] = route['query'][param].substring(0, route['query'][param].length - 1)
                    }
                }
                if (Object.keys(route.query).includes('store_ids') === true || row.type_name === 'budget') {
                    this.$router.push(route)
                } else {
                    this.$refs.taskTable.toggleRowExpansion(row)
                }
            } else if (message === undefined && row.type_name === 'budget') { // Hardcode the budget detail page since that is not available in /messages endpoint
                this.$router.push({ 'path': 'budget', 'query': { 'week': row.week, 'year': row.year, 'level': row.children[0].properties.level } })
            }
        },
        taskClicked (row) {
            if (row.type_name !== 'budget') { // Not complete ticket for budget approve
                this.modifyTicket(row.ticket_id, null)
            }
            let parentRow = this.tableData.find(x => x.type_name === row.type_name)
            let message = this.messages.find(x => x.type_name === row.type_name)
            if (message !== undefined) {
                let route = { 'path': message.linking.url, 'query': {} }
                for (let param of message.linking.params) {
                    if (Object.keys(row).includes(param)) { // If param is also in the row, we can use it as query parameter
                        route['query'][param] = row[param]
                    } else if (Object.keys(parentRow).includes(param)) { // Same holds for parent row
                        route['query'][param] = parentRow[param]
                    } else if (Object.keys(row.properties).includes(param)) {
                        route['query'][param] = row.properties[param]
                    }
                }
                this.$router.push(route)
            } else if (message === undefined && row.type_name === 'budget') { // Hardcode the budget detail page since that is not available in /messages endpoint
                this.$router.push({ 'path': 'budget', 'query': { 'week': row.properties.week, 'year': row.properties.year, 'level': row.properties.level } })
            }
        },
        modifyTicket (ticketID, ticketName) {
            let data = []
            if (ticketID !== null) {
                data.push({ 'ticket_id': ticketID })
            } else {
                let obj = this.tableData.find(x => x.ticket_name === ticketName)
                for (let item of obj.children) {
                    vue.set(item, 'modified', true)
                    data.push({ 'ticket_id': item.ticket_id })
                }
            }

            axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_TICKET_API_BASE_URL_DEV : process.env.VUE_APP_TICKET_API_BASE_URL) + '/modify', data, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_TICKET_API_BASE_URL_DEV : process.env.VUE_APP_TICKET_API_BASE_URL) + '/user_tickets?module=' + this.$props.module, { headers: getHeadersWithAccessToken() })
                        .then(response => {
                            let open = []
                            for (let item of response.data.data) {
                                if (item.modified === false) {
                                    open.push(item)
                                }
                            }
                            vue.set(this.$store.state[this.$props.module], 'ticketsOpen', open.length)
                        })
                        .catch(error => {
                            console.log(error)
                        })
                })
                .catch(error => {
                    console.log(error)
                })
        },
        tableRowClassName ({ row, rowIndex }) {
            if (Object.keys(row).includes('ticket_id')) {
                if (row.modified === false) {
                    return 'success-row'
                }
            } else {
                let modified = true
                for (let item of row.children) {
                    if (item.modified === undefined || item.modified === false) {
                        modified = false
                    }
                }
                if (!modified) {
                    return 'success-row'
                }
            }
        },
        getTasks () {
            axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_TICKET_API_BASE_URL_DEV : process.env.VUE_APP_TICKET_API_BASE_URL) + '/user_tickets?module=' + this.$props.module, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    this.tableData = []
                    this.ticketHeaders = {}

                    for (let item of response.data.data) {
                        if (this.tableData.find(x => x.identifier === item.properties.unique) === undefined) {
                            let obj = { 'identifier': item.properties.unique, 'type_name': item.type_name, 'ticket_name': item.properties.ticket_name, 'year': item.properties.year, 'week': item.properties.week, 'days_open': item.days_open, 'children': [] }
                            let newItem = { 'ticket_id': item.ticket_id, 'modified': item.modified, 'type_name': item.type_name, 'properties': item.properties }
                            this.ticketHeaders[item.properties.ticket_name] = []

                            // Hardcode value and store_id
                            if (Object.keys(item).includes('store_id')) {
                                newItem['store_id'] = item['store_id']
                            }
                            if (Object.keys(item.properties).includes('value')) {
                                newItem['value'] = item.properties['value']
                            }
                            if (Object.keys(item.properties).includes('level')) {
                                newItem['level'] = item.properties['level']
                            }

                            if (Object.keys(newItem).length > 1) {
                                obj['children'].push(newItem)
                            }
                            this.tableData.push(obj)
                        } else {
                            let obj = this.tableData.find(x => x.identifier === item.properties.unique)
                            let idx = this.tableData.indexOf(obj)
                            let newItem = { 'ticket_id': item.ticket_id, 'modified': item.modified, 'type_name': item.type_name, 'properties': item.properties }

                            // Hardcode value and store_id
                            if (Object.keys(item).includes('store_id')) {
                                newItem['store_id'] = item['store_id']
                            }
                            if (Object.keys(item.properties).includes('value')) {
                                newItem['value'] = item.properties['value']
                            }
                            if (Object.keys(item.properties).includes('level')) {
                                newItem['level'] = item.properties['level']
                            }

                            if (Object.keys(newItem).length > 1) {
                                this.tableData[idx].children.push(newItem)
                            }
                        }
                        if (Object.keys(item.properties).includes('value')) {
                            if (this.ticketHeaders[item.properties.ticket_name].find(x => x.prop === 'value') === undefined) {
                                this.ticketHeaders[item.properties.ticket_name].push({ 'prop': 'value', 'label': 'Value' })
                            }
                        }
                        if (Object.keys(item.properties).includes('level')) {
                            if (this.ticketHeaders[item.properties.ticket_name].find(x => x.prop === 'level') === undefined) {
                                this.ticketHeaders[item.properties.ticket_name].push({ 'prop': 'level', 'label': 'Level' })
                            }
                        }
                    }
                    this.loaded = true
                })
                .catch(error => {
                    console.log(error)
                })

            axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_SCHEDULER_API_BASE_URL_DEV : process.env.VUE_APP_SCHEDULER_API_BASE_URL) + '/messages', { headers: getHeadersWithAccessToken() })
                .then(response => {
                    this.messages = response.data.data
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    components: {
        FacebookLoader
    },
    created () {
        this.getTasks()
        if (this.$store.getters['general/allStoresLoaded'] === false) {
            this.$store.dispatch('general/getAllStores').then(response => {
            })
                .catch(error => {
                    console.log(error)
                })
        }

        if (this.$props.module === 'budget') {
            this.headers.push({ 'prop': 'year', 'label': 'Year' })
            this.headers.push({ 'prop': 'week', 'label': 'Week' })
        }
    }
}
</script>

<style lang="scss">
.component-tasks {
    .el-table .success-row {
        background: #e9f4f5;
    }
}
</style>
